import { defineStyle } from '@chakra-ui/react';

export const H1_CONFIG = defineStyle({
  variants: {
    'hoa-h1': {
      color: 'white',
      fontSize: 'xl', // TODO 20px but should be 22px
      fontWeight: 'normal',
    },
    'hoa-h1-md': {
      color: 'white',
      fontSize: '2xl',
      fontWeight: 'normal',
    },
    'calendar-h2': {
      fontSize: 'md',
      fontWeight: 500,
      color: 'white',
    },
  },
});
